import React from "react";
import { Link } from "react-router-dom";


function Ajouter() {
    return (

        <section className="jumbotron text-center mt-45">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                        <Link to={"/formulaire"} className="btn btn-primary btn-widths btn-sm active" role="button" aria-pressed="true">
                            Je suis sur place
                    </Link>

                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 mt-3"> <Link to={"/formulaire-distance"} className="btn btn-primary btn-widths btn-sm active" role="button" aria-pressed="true">
                        Je ne suis pas sur place
                    </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Ajouter;